import { Box } from '@mui/material';
import { SectionHeader, SectionWrapper } from '../../../components/tableComponents';
import { deposit, IDexPropsData, pendingTransaction, transaction } from '../../../types/dex';
import { DepositSectionTable, PendingSectionTable, TxSectionTable } from './AccountTables';

interface DexDataElements {
    deposit: JSX.Element;
    pendings: JSX.Element[];
    transactions: JSX.Element[];
}

function parseData(data: IDexPropsData): DexDataElements {
    let deposit = <></>;
    let pendings = [];
    let transactions = [];

    for (let key in data.assets){
        let asset = data.assets[key];
        if(asset.ledger){
            const _deposit = asset.ledger.find((e: any) => e.action === "Deposit");
            
            if(_deposit) 
                deposit = (
                    <SectionWrapper>
                        <DepositSectionTable deposit={_deposit as deposit} key={"Deposit"}/>
                    </SectionWrapper>
                );

            let _pending = asset.ledger.find((e: any) => e.action === "Pending Transaction");
            
            if (_pending) 
                pendings.push(
                    <SectionWrapper>
                        <PendingSectionTable pending={_pending as pendingTransaction} key={"Pending Transaction"+ _pending.date} />
                    </SectionWrapper>
                );

            let _transaction = asset.ledger.find((e: any) => e.action === "Transaction");
            
            if (_transaction) 
                transactions.push(
                    <SectionWrapper>
                        <TxSectionTable tx={_transaction as transaction} key={"Transaction" + _transaction.date} />
                    </SectionWrapper>
                );
        }
    }
    return {
        deposit,
        pendings,
        transactions
    };
}

interface DexProps {
    data: IDexPropsData, 
}

export default function Dex({ data }: DexProps){
    const { deposit, pendings, transactions } = parseData(data);
    return (
        <Box sx={{ width: '100%', pt: 1,  pl: { sm: 2 }, pr: { xs: 1, sm: 1 }, }} >
            <SectionHeader  title={`Account ID: ${data.account}`}/>
            <SectionHeader  title={`Account Status: ${data.currentPhase}`}/>
            { deposit }
            { pendings }
            { transactions }
        </Box>
    );
}
